import React, { useState } from "react";
import { Link } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { axiosPrivate } from "../../api/PrivateRequestServices";
import Spinner from "../UI/Spinner";
const EnterNumber = ({ setPage, phoneNo, setphoneNo }) => {
  const { auth, setAuth } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  let isvalidPhone = true;
  const [isRequested, setIsRequested] = useState(true);
  const sendOTP = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    const request = {
      comm_value: phoneNo,
      object_type: "delete_user_request",
    };
    let pattern = /^[0-9]{8,10}$/;
    const value = phoneNo;
    if (!pattern.test(value)) {
      setIsLoading(false);
      setError("Invalid Phone Number");
      isvalidPhone = false;
    } else {
      setError("");
      isvalidPhone = true;
    }
    if (isvalidPhone === true && phoneNo != "" && isRequested) {
      setIsRequested(false);
      const url = process.env.REACT_APP_SEND_OTP_NEW;
      const res = await axiosPrivate.post(url, request);
      setIsLoading(true);
      if (res?.error) {
        setIsLoading(false);
        setError("Something Went Wrong");
        setphoneNo("");
        setIsRequested(true);
      } else if (res?.data?.status != 200) {
        setIsLoading(false);
        setError(res?.data?.message);
        setphoneNo("");
        setIsRequested(true);
        Array.from(document.querySelectorAll("input")).forEach(
          (input) => (input.value = "")
        );
      } else {
        if (res?.data?.response?.data?.otp_required) {
          setIsLoading(false);
          setAuth((prev) => {
            return {
              ...prev,
              phone: phoneNo,
              otpRequired: res?.data?.response?.data?.otp_required,
              userId: res?.response?.data?.user_id,
            };
          });
          setPage(1);
        } else {
          setIsLoading(false);
          setError(res?.data?.message);
          setphoneNo("");
        }
      }
    }
  };
  return (
    <div class="formSection">
      {isLoading == true && <Spinner />}
      <div className="form">
        <h5>Enter registered mobile number</h5>

        <div className="dForm">
          <span className={error ? "error" : ""}>
            <input
              required
              onChange={(e) => {
                setphoneNo(e.target.value);
                setError("");
              }}
              type="text"
              minLength={10}
              maxLength={10}
              placeholder="Enter Phone Number"
              name=""
            />
          </span>
          {error && (
            <div class="alertTxt">
              <span class="error">
                <i class="material-symbols-rounded fill mt-s error mr-4">
                  error
                </i>
                {error}
              </span>
            </div>
          )}
        </div>
      </div>
      <div className="actionButtons mt-16">
        <span className="">
          <Link to="" onClick={sendOTP} className="btn prim fullW">
            Send OTP to delete
          </Link>
        </span>
      </div>
    </div>
  );
};

export default EnterNumber;
